import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";
import { KEYCLOAK_AUTHORITY, KEYCLOAK_CLIENT_ID } from "./config";

/** OIDC (Authorization Code + PKCE) settings for the Keycloak `oms-web` client. */
export const oidcConfig: AuthProviderProps = {
    authority: KEYCLOAK_AUTHORITY,
    client_id: KEYCLOAK_CLIENT_ID,
    redirect_uri: window.location.origin,
    post_logout_redirect_uri: window.location.origin,
    response_type: "code",
    scope: "openid profile email",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    // Strip ?code&state from the URL after the redirect callback.
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};
